import { useQuery } from 'react-query';
import { apiService } from '~services/ApiService';

export interface AttendanceStatus {
  is_on_time?: boolean;
  is_late?: boolean;
  is_not_coming?: boolean;
  updated_at?: string;
}

// Hook to get the current attendance status for an order
export const useGetAttendanceStatus = (order_id: string) => {
  return useQuery<AttendanceStatus, Error>(
    ['attendanceStatus', order_id],
    async () => {
      try {
        // This endpoint would return the current attendance status for this order
        // Assuming backend provides this information as part of the order details
        const response = await apiService.get<AttendanceStatus>(`orders/${order_id}/attendance-status`);
        return response;
      } catch (error) {
        console.error('Error fetching attendance status:', error);
        return {
          is_on_time: false,
          is_late: false,
          is_not_coming: false
        };
      }
    },
    {
      enabled: !!order_id,
      staleTime: 60000, // 1 minute
      // If the backend doesn't provide a dedicated endpoint yet, we can handle
      // this data as part of the order details until it's implemented
      onError: () => {
        return {
          is_on_time: false,
          is_late: false,
          is_not_coming: false
        };
      }
    }
  );
};